function FbPixel() {
  const ReactPixel = require('react-facebook-pixel');
  ReactPixel.default.init('393852281032296');
  return {
    ...ReactPixel.default,
  }
}
export default FbPixel();